import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconFavoritesOff16a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.456 1.053c.552-1.404 2.535-1.404 3.087 0l1.36 3.456 3.576.303c1.455.123 2.043 1.921.973 2.89l-2.788 2.524.845 3.742c.324 1.438-1.256 2.58-2.517 1.765L8 13.8l-2.992 1.932c-1.262.814-2.842-.327-2.517-1.765l.844-3.742L.547 7.703c-1.07-.97-.482-2.768.973-2.891l3.576-.303 1.36-3.456ZM8 2.592 6.88 5.437a1.66 1.66 0 0 1-1.404 1.047l-3.013.255 2.36 2.137c.446.403.638 1.015.506 1.6L4.624 13.6 7.1 12.001a1.656 1.656 0 0 1 1.797 0l2.477 1.6-.705-3.125a1.665 1.665 0 0 1 .506-1.6l2.36-2.137-3.013-.255A1.66 1.66 0 0 1 9.12 5.437L8 2.592Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconFavoritesOff16a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconFavoritesOff16 = createIcon(IconComponent);